module.exports = __webpack_public_path__ + "img/complaint-afpi.aa124290.png";